import { render, staticRenderFns } from "./Spouse.vue?vue&type=template&id=7b6e7a7c&scoped=true&"
import script from "./Spouse.vue?vue&type=script&lang=javascript&"
export * from "./Spouse.vue?vue&type=script&lang=javascript&"
import style0 from "./Spouse.vue?vue&type=style&index=0&id=7b6e7a7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e7a7c",
  null
  
)

export default component.exports